export const ONLINE_PLAYER_SESSION_KEY = 'sun_online_player_session';
const LEGACY_ONLINE_PLAYER_TOKEN_HASH_KEY = 'sun_online_player_token_hash';

const memoryStorage = new Map();

const getStoredValue = (key) => {
  try {
    const value = window.localStorage.getItem(key);
    return value === null ? memoryStorage.get(key) || null : value;
  } catch (error) {
    return memoryStorage.get(key) || null;
  }
};

const setStoredValue = (key, value) => {
  memoryStorage.set(key, value);

  try {
    window.localStorage.setItem(key, value);
  } catch (error) {
    // In-memory storage still keeps the current tab usable in restricted browsers.
  }
};

const removeStoredValue = (key) => {
  memoryStorage.delete(key);

  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    // Ignore unavailable browser storage.
  }
};

const getStoredJson = (key, fallback) => {
  try {
    const value = getStoredValue(key);
    return value ? JSON.parse(value) : fallback;
  } catch (error) {
    return fallback;
  }
};

export const getLaunchTokenFromUrl = () => {
  const url = new URL(window.location.href);
  const queryKeys = ['launchToken', 'launch_token', 'token'];

  for (const key of queryKeys) {
    const value = url.searchParams.get(key);
    if (value) return value;
  }

  const hashParams = new URLSearchParams(url.hash.replace(/^#\??/, ''));
  for (const key of queryKeys) {
    const value = hashParams.get(key);
    if (value) return value;
  }

  return '';
};

export const getStoredPlayerSession = () => {
  const session = getStoredJson(ONLINE_PLAYER_SESSION_KEY, null);
  const tokenHash = session?.tokenHash || getStoredValue(LEGACY_ONLINE_PLAYER_TOKEN_HASH_KEY) || '';

  if (!session && !tokenHash) return null;

  return {
    ...(session || {}),
    tokenHash: tokenHash || session?.tokenHash || '',
  };
};

export const persistPlayerSession = (session) => {
  if (!session?.tokenHash) return;

  setStoredValue(ONLINE_PLAYER_SESSION_KEY, JSON.stringify(session));
  removeStoredValue(LEGACY_ONLINE_PLAYER_TOKEN_HASH_KEY);
};

export const clearPersistedPlayerSession = () => {
  removeStoredValue(ONLINE_PLAYER_SESSION_KEY);
  removeStoredValue(LEGACY_ONLINE_PLAYER_TOKEN_HASH_KEY);
};

export const isPlayerSessionExpired = (session) => {
  if (!session?.expiredAt) return false;

  const expiredAtTime = new Date(session.expiredAt).getTime();
  return Number.isFinite(expiredAtTime) && expiredAtTime <= Date.now();
};

export const getPlayerSessionHeaders = (session = {}) => {
  const tokenHash = session.tokenHash || '';
  const headers = {};

  if (tokenHash) {
    headers.Authorization = `Bearer ${tokenHash}`;
    headers['X-Token-Hash'] = tokenHash;
  }

  return headers;
};

export const isSessionAuthorizationError = (error) => (
  error?.response?.status === 401 || error?.response?.status === 403
);

export const isNetworkRequestError = (error) => !error?.response;
